import lazyLoading from './lazyLoading.js'

export default {
  name: 'syncs',
  meta: {
    title: 'Syncs',
    iconClass: 'vuestic-icon vuestic-icon-forms'
  },
  path: '/syncs',
  component: lazyLoading('syncs/Syncs')
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/syncs.js